import styled from 'styled-components';
import { rem } from '@/styles/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
  padding: ${rem(16)} ${rem(18)};
  ${({ theme }) => theme.media.fold`
    gap: ${rem(14)};
    padding: ${rem(14)} ${rem(20)};
  `}
`;
